import React from "react";
import { useReveal } from "@/hooks/useReveal";

export default function RevealOnView({
  as: Tag = "div",
  delay = 0,
  className = "",
  children,
  ...rest
}) {
  const { ref, visible } = useReveal();
  const delayClass =
    delay > 0 ? `reveal-delay-${Math.min(Math.max(delay, 1), 5)}` : "";
  return (
    <Tag
      ref={ref}
      className={`reveal ${delayClass} ${
        visible ? "is-visible" : ""
      } ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
